import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg ${isScrolled ? 'nav-scroll' : ''}`}>
      <div className="container">
        <div className="logo-wrapper">
          <Link className="logo" to="/">
            <img src={isScrolled ? '/img/logos/brown logo.png' : '/img/whitelogo.png'} className="logo-img" alt="Sintra Hotel" />
          </Link>
        </div>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbar" 
          aria-controls="navbar" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" style={{ width: '2.5em', height: '3.5em' }}>
            <i className="ti-menu" style={{ fontSize: 'large' }}></i>
          </span>
        </button>
        <div className="collapse navbar-collapse" id="navbar">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item dropdown">
              <a 
                className="nav-link dropdown-toggle" 
                href="#" 
                role="button" 
                data-bs-toggle="dropdown" 
                data-bs-auto-close="outside" 
                aria-expanded="false"
              >
                Rooms & Suites<i className="ti-angle-down"></i>
              </a>
              <ul className="dropdown-menu">
                <li className="nav-item">
                  <Link className="dropdown-item" to="/rooms/executive">
                    <span>Executive Room</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="dropdown-item" to="/rooms/twin-executive">
                    <span>Twin Executive Room</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="dropdown-item" to="/rooms/super-deluxe">
                    <span>Super Deluxe Room</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/gallery">Gallery</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/decor">Decor</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/places-activities">Places & Activities</Link>
            </li>
            <li className="nav-item dropdown">
              <a 
                className="nav-link dropdown-toggle" 
                href="#" 
                role="button" 
                data-bs-toggle="dropdown" 
                data-bs-auto-close="outside" 
                aria-expanded="false"
              >
                Cafe & Restaurant<i className="ti-angle-down"></i>
              </a>
              <ul className="dropdown-menu">
                <li className="nav-item">
                  <Link className="dropdown-item" to="/restaurant">
                    Spice Fusion
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="dropdown-item" to="/restaurant">
                    Cafe SOIR
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/blogs">Blog</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
